module.exports = "/_next/static/images/energyRebates-63361c9d255b25ee7b7f5c152c1e3a7d.webp";